import { Injectable } from '@angular/core';
import { DataService } from '../data.service';
import { HttpClient, HttpHeaders } from '@angular/common/http';

import { environment } from '../../../environments/environment';
import { CommonFunctionService, UserMerchantData } from '../Common/common-function.service';
import { PaymentTransaction } from 'src/app/models/payment-transaction';
import { VposBatchAppView } from 'src/app/models/vpos-batch-app-view';
import { Paymentledger } from 'src/app/models/paymentledger';
import { catchError, map } from 'rxjs';

@Injectable()
export class ReportsService {
  headers: any;
  token: any;
  header: any;
  constructor(private service: DataService, private http: HttpClient, private common: CommonFunctionService) {
    let loggedUsername = this.common.getUserName()
    const merchantdata: UserMerchantData = this.common.getUserMerchantData();
    this.token = environment.GetAuthenticationToken + ":" + this.common.GetAuthToken() + ":" + "IT" + ":" + environment.GetAuthencticationKey + ":" + this.common.getSid() + ":" + merchantdata.MerchantKeyId;
    this.headers = new HttpHeaders().
      set('Authorization', 'basic ' + btoa(this.token));
  }
  GetTransactionSummary(data, startdate, enddate) {
    this.GetHeaderdetails();
    const merchantdata: UserMerchantData = this.common.getUserMerchantData();
    return this.http.get<VposBatchAppView>(environment.getTransactionSummaryReport + "?merchantKeyId=" + data + "&startDate=" + startdate + "&endDate=" + enddate+ "&LoginUserId="+merchantdata.UserId
    , { headers: this.headers });
    // .map(response => response) .catch(this.common.handleError);
  }
  GetTranReports(merchantKeyId, searchType) {
    this.GetHeaderdetails();
    const merchantdata: UserMerchantData = this.common.getUserMerchantData();
    return this.http.get<VposBatchAppView>(environment.getTransactionReportsUrl + "?merchantKeyId=" + merchantKeyId + "&searchType=" + searchType+ "&LoginUserId="+merchantdata.UserId
    , { headers: this.headers });
  }
  GetTransactionReportsByDateRange(data, startdate, enddate, searchType) {
    this.GetHeaderdetails();
    const merchantdata: UserMerchantData = this.common.getUserMerchantData();
    return this.http.get<VposBatchAppView>(environment.getTranReportsByDateRangeUrl + "?merchantKeyId=" + data + "&datefrom=" + startdate + "&dateTo=" + enddate + "&searchType=" + searchType+ "&LoginUserId="+merchantdata.UserId
    , { headers: this.headers });
  }
  ViewOrderFailureLogDetails(data) {
    this.GetHeaderdetails();
    return this.http.post<any>(environment.ViewOrderFailureLogDetailsUrl, data, { headers: this.headers })
    .pipe(map(response => response)
    ,catchError(this.common.handleError));
  }
  GetSettledTransactions(data, batchId, startdate, enddate) {
    this.GetHeaderdetails();
    const merchantdata: UserMerchantData = this.common.getUserMerchantData();
    return this.http.get<PaymentTransaction>(environment.getSettledTransactionsReport + "?merchantKeyId=" + data + "&batchid=" + batchId + "&startDate=" + startdate + "&endDate=" + enddate + "&LoginUserId=" + merchantdata.UserId
      , { headers: this.headers });
    // .map(response => response) .catch(this.common.handleError);
  }
  // GetSettledTransactions(data,batchid,startdate,enddate)
  // {
  //   return this.http.get(environment.getSettledTransactionsReport+"?merchantKeyId="+data+"&batchid="+batchid+"&startDate="+startdate+"&endDate="+enddate) ; 
  //   // .map(response => response) .catch(this.common.handleError);
  // } 
  ViewSettledTransaction(data, MerchantKeyId) {
    this.GetHeaderdetails();
    const merchantdata: UserMerchantData = this.common.getUserMerchantData();
    return this.http.get<PaymentTransaction>(environment.GetSettledTransactionUrl + "?MerchantKeyId=" + MerchantKeyId + "&batchid=" + data + "&LoginUserId=" + merchantdata.UserId
      , { headers: this.headers })
      .pipe(map(response => response)
      ,catchError(this.common.handleError));
  }

  GetPaymentLedgerDetails(Id, accountId) {
    this.GetHeaderdetails();
    const merchantdata: UserMerchantData = this.common.getUserMerchantData();
    return this.http.get<Paymentledger>(environment.GetPaymentLedgerDetailsUrl + "?id=" + Id
      + "&merchantkeyid=" + accountId+ "&LoginUserId="+merchantdata.UserId
      , { headers: this.headers });
  }
  GetPaymentLedgerDetailView(entryIds, accountId) {
    this.GetHeaderdetails();
    const merchantdata: UserMerchantData = this.common.getUserMerchantData();
    return this.http.get<Paymentledger>(environment.GetPaymentLedgerDetailViewUrl + "?entryIds=" + entryIds
      + "&merchantkeyid=" + accountId+ "&LoginUserId="+merchantdata.UserId
      , { headers: this.headers });
  }


  GetTransactionListByQuickCodeAndDate(QuickCode, MerchantKeyId, TransactionDateTime) {
    this.GetHeaderdetails();
    const merchantdata: UserMerchantData = this.common.getUserMerchantData();
    return this.http.get<any>(environment.GetTransactionListByQuickCodeandDate + "?MerchantKeyId=" + MerchantKeyId
      + "&QuickCode=" + QuickCode + "&TransactionDateTime=" + TransactionDateTime+ "&LoginUserId="+merchantdata.UserId
      , { headers: this.headers });
  }

  getFeeAndGSTReportsListUrl(MerchantKeyId) {
    this.GetHeaderdetails();
    const merchantdata: UserMerchantData = this.common.getUserMerchantData();
    return this.http.get<any>(environment.getFeeAndGSTReportsListUrl + "?MerchantkeyId=" + MerchantKeyId+ "&LoginUserId="+merchantdata.UserId
    , { headers: this.headers });
  }
  getFeeAndGSTTranLevelListUrl(viewMerchantkeyId, NumericYearMonth) {
    this.GetHeaderdetails();
    const merchantdata: UserMerchantData = this.common.getUserMerchantData();
    return this.http.get<any>(environment.getFeeAndGSTTranLevelListUrl + "?MerchantkeyId=" + viewMerchantkeyId + "&monthYear=" + NumericYearMonth+ "&LoginUserId="+merchantdata.UserId
    , { headers: this.headers });


  }

  GetMISList(data)
  {
    this.GetHeaderdetails();
    return this.http.post<any>(environment.GetMISList,data,{headers:this.headers})
  }

  getFeeAndGSTTranLevelFilterUrl(viewMerchantkeyId, txtTransactionId, Fromdate1, todate1, txtAmount, txtAmountCheck, txtPaymentType) {
    this.GetHeaderdetails();
    const merchantdata: UserMerchantData = this.common.getUserMerchantData();
    return this.http.get<any>(environment.getFeeAndGSTTranLevelFilterUrl + "?merchantKeyId=" + viewMerchantkeyId +
      "&transactionId=" + txtTransactionId
      + "&fromdate=" + Fromdate1 + "&todate=" + todate1 +
      "&amount=" + txtAmount +
      "&symbol=" + txtAmountCheck + "&paymenttype=" + txtPaymentType+ "&LoginUserId="+merchantdata.UserId
      , { headers: this.headers });

  }

  PaymentLedgerUrl(MerchantKeyId) {
    this.GetHeaderdetails();
    const merchantdata: UserMerchantData = this.common.getUserMerchantData();
    return this.http.get<any>(environment.PaymentLedgerUrl + "?MerchantKeyId=" + MerchantKeyId+ "&LoginUserId="+merchantdata.UserId
    , { headers: this.headers });
  }


    PaymentLedgerFilterdataurl(data) 
    {
    this.GetHeaderdetails();
    // const merchantdata: UserMerchantData = this.common.getUserMerchantData();
    // return this.http.get<any>(environment.PaymentLedgerFilterdataurl + "?MerchantKeyId=" + MerchantKeyId + "&fromdate=" + Fromdate1 + "&todate=" + todate1 + "&TransactionType=" + tType +
    //   "&PaymentType=" + pType + "&Amount=" + Amount + "&Batchid=" + bid + "&AmountCheck=" + amountcompare+ "&LoginUserId="+merchantdata.UserId
    //   , { headers: this.headers });
      return this.http.post<any>(environment.PaymentLedgerFilterdataurl,data,{headers:this.headers})

  }
  getTransactionSummaryFilterUrl(data) {
    this.GetHeaderdetails();
    const merchantdata: UserMerchantData = this.common.getUserMerchantData();
    return this.http.post<any>(environment.getTransactionSummaryFilterUrl,data,{ headers: this.headers });
  }


  getQuickcodeTransactionSummaryUrl(viewMerchantkeyId) {
    this.GetHeaderdetails();
    const merchantdata: UserMerchantData = this.common.getUserMerchantData();
    return this.http.get<any>(environment.getQuickcodeTransactionSummaryUrl + "?MerchantKeyId=" + viewMerchantkeyId+ "&LoginUserId="+merchantdata.UserId
    , { headers: this.headers });

  }
  getFilteredTransactionSummaryUrl(data) {
    this.GetHeaderdetails();
    const merchantdata: UserMerchantData = this.common.getUserMerchantData();
    return this.http.post<any>(environment.getFilteredTransactionSummaryUrl,data,{ headers: this.headers });

  }
  GetposbackdataUrl(viewMerchantkeyId) {
    this.GetHeaderdetails();
    const merchantdata: UserMerchantData = this.common.getUserMerchantData();
    return this.http.get<any>(environment.GetposbackdataUrl + "?MerchantKeyId=" + viewMerchantkeyId+ "&LoginUserId="+merchantdata.UserId
    , { headers: this.headers });

  }

  getFeeAndGSTCertificate(viewMerchantkeyId, NumericYearMonth) {
    this.GetHeaderdetails();
    const merchantdata: UserMerchantData = this.common.getUserMerchantData();
    return this.http.get<any>(environment.getFeeAndGSTCertificate + "?MerchantkeyId=" + viewMerchantkeyId + "&monthYear=" + NumericYearMonth+ "&LoginUserId="+merchantdata.UserId
    , { headers: this.headers });

  }
  GetFundreportfilterurl(MerchantKeyId, Fromdate1, todate1) {
    this.GetHeaderdetails();
    const merchantdata: UserMerchantData = this.common.getUserMerchantData();
    return this.http.get<any>(environment.GetFundreportfilterurl + "?MerchantKeyId=" + MerchantKeyId + "&fromdate=" + Fromdate1 + "&todate=" + todate1
    + "&LoginUserId="+merchantdata.UserId
    , { headers: this.headers });

  }
  GetPostbackdatafilterurl(MerchantKeyId, Fromdate1, todate1) {
    this.GetHeaderdetails();
    const merchantdata: UserMerchantData = this.common.getUserMerchantData();
    return this.http.get<any>(environment.GetPostbackdatafilterurl + "?MerchantKeyId=" + MerchantKeyId + "&fromdate=" + Fromdate1 + "&todate=" + todate1
    + "&LoginUserId="+merchantdata.UserId
    , { headers: this.headers });

  }
  GetpayoutposbackdataUrl(viewMerchantkeyId) {
    this.GetHeaderdetails();
    const merchantdata: UserMerchantData = this.common.getUserMerchantData();
    return this.http.get<any>(environment.GetpayoutposbackdataUrl + "?MerchantKeyId=" + viewMerchantkeyId+ "&LoginUserId="+merchantdata.UserId
    , { headers: this.headers });

  }
  GetPayoutPostbackdatafilterurl(MerchantKeyId, Fromdate1, todate1) {
    this.GetHeaderdetails();
    const merchantdata: UserMerchantData = this.common.getUserMerchantData();
    return this.http.get<any>(environment.GetPayoutPostbackdatafilterurl + "?MerchantKeyId=" + MerchantKeyId + "&fromdate=" + Fromdate1 + "&todate=" + todate1
    + "&LoginUserId="+merchantdata.UserId
    , { headers: this.headers });

  }
  GetPayoutBalanceReportUrl(viewMerchantkeyId) {
    this.GetHeaderdetails();
    return this.http.get<any>(environment.GetPayoutBalanceReportUrl + "?MerchantKeyId=" + viewMerchantkeyId, { headers: this.headers });

  }
  GetPayoutBalanceReportfilterUrl(MerchantKeyId, Fromdate1, todate1, PayoutProcessor) {
    this.GetHeaderdetails();
    return this.http.get<any>(environment.GetPayoutBalanceReportfilterUrl + "?MerchantKeyId=" + MerchantKeyId + "&fromdate=" + Fromdate1 + "&todate=" + todate1 + "&payoutProcessor=" + PayoutProcessor
      , { headers: this.headers });

  }


  GetHeaderdetails() {
    let loggedUsername = this.common.getUserName()
    const merchantdata: UserMerchantData = this.common.getUserMerchantData();
    this.token = environment.GetAuthenticationToken + ":" + this.common.GetAuthToken() + ":" + "IT" + ":" + environment.GetAuthencticationKey + ":" + this.common.getSid() + ":" + merchantdata.MerchantKeyId;
    this.headers = new HttpHeaders().
      set('Authorization', 'basic ' + btoa(this.token));


  }

  getReconciliationReport(data) {
    this.GetHeaderdetails();
    return this.http.post<any>(environment.ReconciliationReportUrl, data, { headers: this.headers });
  }
  filterPayoutFailureLogsUrl(data) {


    this.token = environment.GetAuthenticationToken + ":" + this.common.GetMMSAuthToken() + ":" + "IT" + ":" + environment.GetAuthencticationKey + ":" + this.common.getSid() + ":" + this.common.getUserMerchantData().ResellerId;
    this.headers = new HttpHeaders().
      set('Authorization', 'basic ' + btoa(this.token));
    return this.http.post<any>(environment.filterPayoutFailureLogsUrl, data, { headers: this.headers })
  }
  ViewPayoutFailureLogDetails(orderid) {
    this.token = environment.GetAuthenticationToken + ":" + this.common.GetMMSAuthToken() + ":" + "IT" + ":" + environment.GetAuthencticationKey + ":" + this.common.getSid() + ":" + this.common.getUserMerchantData().ResellerId;
    this.headers = new HttpHeaders().
      set('Authorization', 'basic ' + btoa(this.token));

    var MerchantKeyId = this.common.getUserMerchantData().MerchantKeyId;
    var ResellerId = this.common.getUserMerchantData().ResellerId;
    var LogInResellerId = this.common.getUserMerchantData().ResellerId;
    return this.http.get<any>(environment.ViewPayoutFailureLogDetailsUrl + "?id=" + orderid + "&MerchantKeyId=" + MerchantKeyId + "&ResellerId=" + ResellerId + "&LogInResellerId=" + LogInResellerId, { headers: this.headers })
      .pipe(map(response => response)
      ,catchError(this.common.handleError));
  }
  Merchantstatementdata(data) 
  {
  this.GetHeaderdetails();
  
    return this.http.post<any>(environment.MerchantstatementData,data,{headers:this.headers})

}


}
